<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    
    

      
      
      
    </base-header>

    <!--start container-->
    <div class="container-fluid mt--6">
   	 <div v-if="displayIncorpForm==0 && displayIncorpForm==0 " class="row justify-content-center">
     	<div class="col-x-3" style="padding:10px;">
     		<card style="min-height:350px;min-width:300px;text-align:center;cursor:pointer;padding:5px 20px 50px 20px;" >
     			<div  @click="startIncorpForm">
     				<div  style="width:110px;height:110px;" class="icon  icon-shape bg-gradient-success text-white shadow rounded-circle">
     					<i class="ni ni-spaceship " style="font-size:45px;"></i>
     				</div>
     				
     				<div style="margin-top:30px;"><!-- start: body-->
     					<div class="pt-4 text-center">
						  <h5 class="h3 title">
							<span class="d-block mb-1" >Start A New Company</span>
							<small class="h4 font-weight-light text-muted">Incorporation & Company Secretary</small>
						  </h5>
						  </div>
						  
						  <div style="margin-top:30px;">
						  	<h1 class="text-warning heading-title" style="font-size:32px;">$1000</h1> 
						  	<h5 class="text-muted">PER YEAR</h5>
						  	<div style="font-size:11px;color:#ccc">$550 (Incorporation Fee) <br/> $450 (Company Secretary Fee)</div>
						  </div>
     				
     				</div><!-- end: body-->     				
     			</div>

     		</card>
		</div>
		
		<div class="col-x-3"  style="padding:10px">
     		<card style="min-height:350px;min-width:300px;text-align:center;cursor:pointer;padding:5px 20px 50px 20px;">
     			<div   @click="startAppointForm">
     				<div  style="width:110px;height:110px;" class="icon  icon-shape bg-gradient-warning text-white shadow rounded-circle">
     					<i class="fa fa-user-edit " style="font-size:45px;"></i>
     				</div>
     				
     				<div style="margin-top:30px;"><!-- start: body-->
     					<div class="pt-4 text-center">
						  <h5 class="h3 title">
							<span class="d-block mb-1">Appoint Us As Secretary</span>
							<small class="h4 font-weight-light text-muted">Company Secretary</small>
						  </h5>
						  </div>
						  
						  <div style="margin-top:30px;">
						  	<h1 class="text-warning heading-title" style="font-size:32px;">$550</h1> 
						  	<h5 class="text-muted">PER YEAR</h5>
						  	<br/>
						  </div>
     				
     				</div><!-- end: body-->     				
     			</div>

     		</card>
		</div>



       </div><!-- end row-->
       
       
    
    
    
    <!-- start form wizard row -->
    <div v-if="0" class="row justify-content-center">
        	 <div class="col-xl-8">
        	 
       
      		 </div><!-- end col -->
    </div>
    <!-- end form wizard row -->
    
    
       
    </div>  <!--End container-->
    
    
    

    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';
   import { Select, Option } from 'element-ui'
  
  import {FormWizard, TabContent, WizardButton, WizardStep} from 'vue-form-wizard'
  import  '@/components/FormWizard/vue-form-wizard.min.css'
  
   import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'
   
   
  export default {
    components: {
  		FormWizard, TabContent, WizardButton, WizardStep,
  		 [Select.name]: Select,
     	 [Option.name]: Option,
     	 VueBootstrapTypeahead
     	 
    },
    data() {
      return {
     	 query: '',
      	 ssic_info:{
      	 	code:'',
      	 	title:'',
      	 	title_and_code:'',
      	 },
      	 ssiccodes: [],
      
      	 search_ssic:{
      	 	term:'',
      	 
      	 },
      
     	 displayIncorpForm:0,
     	 displayAppointForm:0,
     	 displayAddDirectorForm: false,
     	 displayAddShareholderForm: false,
     	 hasOwnAddress: true,
     	 invoice:[],
     	 people_array:[],
     	 shareholder: {
     	 	nationality:"SG",
     	 },
     	 director: {
     	 	nationality:"SG",
     	 	is_shareholder:0,
     	 },
     	 model:{
     	 	directors:[],
     	 	shareholders:[],
     	 	hasOwnAddress:true,
     	 	hasOwnLocalDirector: true,
     	 	person:[],
     	 	company:[],
     	 },
     	 directors_array:[] ,
     	 shareholders_array:[] ,
     	 hasOwnLocalDirector: true,
     	 person:{
     	 	nationality:"SG",
     	 	position: "d",
     	 
     	 },
     	 company:{
     	 	country:"SG",
     	 	sources_arr: [],
     	 	address_1:'',
     	 	address_2:'',
     	 	zipcode:'',
     	 	name:'',
     	 	ssic:'',
     	 	ssic_title:'',
     	 	business_nature:'',
     	 	/*sources:{
     	 		personal_savings:false,
     	 		loans_bank: false,
     	 		loans_family: false,
     	 		inheritance: false,
     	 		investors: false,
     	 		profit_investment: false,
     	 	},*/
     	 },
     	 countries:[],
     	 selects: {
          countries: [
            {value: 'SG', label: 'Singapore'},
		   ],
			yesno: [
            {value: 1, label: 'Yes'},
             {value: 0, label: 'No'},
		   ],
		    positions: [
            {value: 'd', label: 'Director'},
            {value: 's', label: 'Shareholder'},
            {value: 'ds', label: 'Director & Shareholder'},
		   ],
		},
	
      };
    },
    
    watch: {
    // When the query value changes, fetch new results from
    // the API - in practice this action should be debounced
    query(newQuery) {
   		 if(this.selectedUser){
   			 console.log("selectedU:"+this.selectedUser.code);
    	}
    	this.search_ssic.term = newQuery;
    	let uri = this.$base_url+'/api/v1/c/search_ssic';
			 ApiService.post(uri, this.search_ssic).then(response => {
			 	this.ssiccodes = response.data.results;
			 })
    
    
    }
  },
  
  filters: {
    stringify(value) {
      return JSON.stringify(value, null, 2)
    }
  },
  
    methods: {
     startAppointForm(){
    		this.$router.push( 'onboarding-appoint-form');
     },
     startIncorpForm(){
     	this.$router.push( 'onboarding-incorp-form');
     
     },
      startIncorpForm_1() {
      		swal.showLoading();
      		this.displayIncorpForm = 1;
      		
      		const vm = this;
      		
      		let uri = this.$base_url+'/api/v1/c/get_init_onboarding';
			 ApiService.post(uri, this.model).then(response => {
				if(response.data.invoice){
					let c = response.data.company;
					this.company.name = c.entity_name;
					
					
					this.company.ssic = c.activity_1_code;
					this.company.business_nature = c.activity_1_desc;
					
					this.ssic_info.code =  c.activity_1_code;
					this.ssic_info.title = c.activity_1_title;
					
					this.company.sources_arr =c.sources_arr;
					this.hasOwnAddress = c.own_address;
					this.hasOwnLocalDirector = c.own_local_director;
					
					this.company.address_1 = c.address_1;
					this.company.address_2 = c.address_2;
					this.company.zipcode = c.zipcode;
					
					this.countries = response.data.countries;
										
					
					this.invoice = response.data.invoice;
					
					response.data.people.forEach(function(p) {
						
						if(p.is_client==1){
							vm.person.first_name = p.first_name;
							vm.person.last_name = p.last_name;
							vm.person.gov_id = p.gov_id;
							vm.person.nationality = p.nationality;
							vm.person.contact_number = p.contact_number;
							
							if(p.is_director && p.is_shareholder){
								vm.person.position ="ds";
							}
							else if(p.is_director){
								vm.person.position ="d";
							}
							else if(p.is_shareholder){
								vm.person.position ="s";
							}
							else{
								vm.person.postion = "c";
							}
						}
						
						if(p.is_client!=1){
							var pp ={
									first_name: p.first_name,
									last_name: p.last_name,
									nationality: p.nationality,
									is_director: p.is_director,
									is_shareholder: p.is_shareholder,
							 };
							 
							 vm.people_array.push(pp);
						 }
						
						
						
						
						if(p.is_client!=1 && p.is_director==1  && p.is_shareholder==1) {
							var pp ={
								first_name: p.first_name,
								last_name: p.last_name,
								nationality: p.nationality,
								is_director: 1,
								is_shareholder:1
							};
							vm.directors_array.push(pp);
							vm.shareholders_array.push(pp);
						}
						
						else if(p.is_client!=1  && p.is_director!=1  && p.is_shareholder==1){
							var pp ={
								first_name: p.first_name,
								last_name: p.last_name,
								nationality: p.nationality,
								is_director: 0,
								is_shareholder:1
							};
						
							vm.shareholders_array.push(pp);
						}
						else if(p.is_client!=1  && p.is_director==1 && p.is_shareholder!=1){
							var pp ={
								first_name: p.first_name,
								last_name: p.last_name,
								nationality: p.nationality,
								is_director: 1,
								is_shareholder:0
							};
						
							vm.directors_array.push(pp);
						}
						
						
						
						
					});//end foreach
					
					//this.$router.push( '/view-invoice/'+	this.invoice.id);
					
					//this.$refs.onboarding_wiz.changeTab(0,2);
				}
				
				
				swal.close();
			}) 
			
			
			
      },
      toggleAddDirectorForm(){
      	if(this.displayAddDirectorForm == true){
      		this.displayAddDirectorForm = false;
      	}
      	else{
      		this.displayAddDirectorForm = true;
      	}
      	
      },
       toggleAddShareholderForm(){
      	if(this.displayAddShareholderForm == true){
      		this.displayAddShareholderForm = false;
      	}
      	else{
      		this.displayAddShareholderForm = true;
      	}
      	
      },
      toggleUseEasilyAddress(){
      
      	if(this.hasOwnAddress== true){
      		this.hasOwnAddress = false;
      	}
      	else{
      		this.hasOwnAddress = true;
      	}
      },
       toggleUseEasilyDirector(){
      
      	if(this.hasOwnLocalDirector== true){
      		this.hasOwnLocalDirector = false;
      	}
      	else{
      		this.hasOwnLocalDirector = true;
      	}
      },
      goToMembersTab(){
      	 // this.$refs.company_d_form.submit();
      	 // return this.companyDetailsCorrect;
      	return true;
      },
     goBack(){
      
      		this.$refs.onboarding_wiz.prevTab();
      },
      addDirector(){
      		if(this.director.is_shareholder == 1){
      			
      			this.director.is_shareolder = 1;
      		}
      		else{
      			this.director.is_shareolder = 0;
      		}
      		
      		this.director.is_director = 1;

      		let t = JSON.parse(JSON.stringify(this.director));
    		this.people_array.push(t);
      		
      		
    		
    		this.toggleAddDirectorForm();
    		this.director.first_name = '';
    		this.director.last_name = '';
    		this.director.is_shareholder = 0;
    		
      
      },
       addShareholder(){
       		this.shareholder.is_director = 0;
       		this.shareholder.is_shareholder = 1;
      		let t = JSON.parse(JSON.stringify(this.shareholder));
    		this.people_array.push(t);
    		
    		this.toggleAddShareholderForm();
    		this.shareholder.first_name = '';
    		this.shareholder.last_name = '';
      
      },
      removeDirector(index){
      	this.removingAlert();
      	this.people_array.splice(index, 1);
      	
      },
      removeShareholder(index){
      	this.removingAlert();
      	this.people_array.splice(index, 1);
      	
      
      },
      removingAlert(){
      		swal.fire({
							title: "Notice",
							text: "This person will be removed as director and/or shareholder.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
					return false;
      
      },
    
      async validateMembersDetails(){
      		var passed = true;
      		var error_msg = "";
      		
      		var director_count = 0;
      		var shareholder_count = 0;
      		
      		this.people_array.forEach(function(p) {
      			if(p.is_shareholder){
      				shareholder_count +=1;
      			}
      			
      			if(p.is_director){
      				director_count +=1;
      			}
      		
      		});
      		
      		if(this.person.position=="d" || this.person.position=="ds" ){
      			director_count +=1;
      		}
      		
      		if(this.person.position=="s" || this.person.position=="ds" ){
      			shareholder_count +=1;
      		}
      		
      		
      		if(director_count ==0 || shareholder_count==0){	
      			passed = false;
      		}
      		
      		if(director_count == 0 && shareholder_count>0){		
      			error_msg = "Please add at least one director";
      		}
      		else if(director_count > 0 && shareholder_count==0){		
      			error_msg = "Please add at least one shareholder";
      		}
      		else if(director_count==0  && shareholder_count==0){		
      			error_msg = "Please add at least one director and at least one shareholder";
      		}
      		
      		
      		if(passed){
 
				swal.showLoading();
		
				this.model.directors = this.directors_array;
				this.model.shareholders = this.shareholders_array;
				this.model.people = this.people_array;
				this.model.hasOwnAddress = this.hasOwnAddress;
				this.model.hasOwnLocalDirector = this.hasOwnLocalDirector;
				this.model.person = this.person;
				this.model.company = this.company;
				
				this.model.signup_type =  "incorp_and_appoint";
			
				let uri = this.$base_url+'/api/v1/c/save_onboarding';
				 ApiService.post(uri, this.model).then(response => {
					swal.close();
					if(response.data.invoice){
						this.$router.push( '/view-invoice/'+	response.data.invoice.id);
					}
				
				})
			}
			
			else{
			
			
					swal.fire({
							title: `Oops`,
							text:  error_msg,
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
					return false;
			
			
			
			} 
      },
      async validateCompanyDetails(){
      		//console.log(this.company.sources_arr);
      		this.company.ssic = this.ssic_info.code;
      		this.company.ssic_title = this.ssic_info.title;
      		
      		if(this.company.sources_arr.length==0){
      		
      				swal.fire({
							title: `Oops`,
							text: "Please select at least one source of funds.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
					return false;
      		 }
      		 
      		 if(this.hasOwnAddress && !(this.company.address_1 && this.company.zipcode)){
      		 	swal.fire({
							title: `Oops`,
							text: "Please complete your address.",
							buttonsStyling: false,
							confirmButtonClass: 'btn btn-warning',
							icon: 'warning'
						  })
						  
				return false;
      		 }
      	

      		
			
			if(this.company.sources_arr.length!=0){
      			this.$refs.onboarding_wiz.nextTab();
      			 window.scrollTo(0,0);
      		}
      		
      	
      },
    },
    mounted() {
			
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}

.stepTitle{
	font-size:17px;
	font-weight:lighter;

}


</style>














